/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ————————');
      // console.log(container);
      // console.log('Variant ——————————');
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ————————————');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();





(function(){
  function initGlobalToggle() {
   
    document.querySelectorAll('.global-image-toggle').forEach(container => {
     
      if (container.dataset.toggleBound) return;
      container.dataset.toggleBound = 'true';

      container.addEventListener('click', function(e) {
        const btn = e.target.closest('.toggle-icon');
        if (!btn) return;

       
        container.querySelectorAll('.toggle-icon')
          .forEach(b => b.classList.toggle('active', b === btn));

        const idx = Number(btn.dataset.viewIndex);

      
        document.querySelectorAll('product-grid-item-variant').forEach(item => {
          item.querySelectorAll('product-grid-item-image').forEach(img => {
            img.classList.toggle(
              'is-active',
              Number(img.dataset.gridImage) === idx
            );
          });
          
          item.querySelectorAll('.product-grid-item__pagination [data-grid-page]')
            .forEach(dot => {
              dot.classList.toggle(
                'is-active',
                Number(dot.dataset.gridPage) === idx
              );
            });
        });
      });
    });

 
  }

  document.addEventListener('DOMContentLoaded',    initGlobalToggle);
  document.addEventListener('theme:scroll',         initGlobalToggle);
  document.addEventListener('theme:section:load',   initGlobalToggle);
})();





/*Code for Nav */

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.mobile-nav__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
});




/* ─── Manual grid-image slider ─── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-grid-item__images').forEach(container => {
    const slides = Array.from(
      container.querySelectorAll('.product-grid-item__image-wrapper')
    );

    if (slides.length <= 1) return; // nothing to slide

    let idx = slides.findIndex(s => s.classList.contains('is-active'));
    if (idx < 0) idx = 0;

   
    function hydrateTemplate(slide) {
      const tpl = slide.querySelector('template');
      if (!tpl) return;                 // already hydrated
      slide.insertAdjacentHTML('beforeend', tpl.innerHTML);
      tpl.remove();
    }

   
    function show(i) {
      slides[idx].classList.remove('is-active');
      idx = i;
      hydrateTemplate(slides[idx]);
      slides[idx].classList.add('is-active');
    }

    
    container.querySelector('.product-slider-prev')
      .addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        show((idx - 1 + slides.length) % slides.length);
      });

    container.querySelector('.product-slider-next')
      .addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        show((idx + 1) % slides.length);
      });

 
    hydrateTemplate(slides[idx]);
  });
});
